import { workFlowConstants } from "../constants";

const initialState = {
  loading: false,
  error: null,
  items: null,
};

export const WorkFlowData = (state = initialState, action) => {
  switch (action.type) {
    case workFlowConstants.CONTINUE_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
        items: null,
        error: null,
      };

    case workFlowConstants.CONTINUE_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
        error: null,
      };

    case workFlowConstants.CONTINUE_WORKFLOW_FAILURE:
      return {
        ...state,
        loading: false,
        items: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const CancelWFData = (state = initialState, action) => {
  switch (action.type) {
    case workFlowConstants.CANCEL_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
        items: null,
        error: null,
      };

    case workFlowConstants.CANCEL_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload,
        error: null,
      };

    case workFlowConstants.CANCEL_WORKFLOW_FAILURE:
      return {
        ...state,
        loading: false,
        items: null,
        error: action.payload,
      };
    default:
      return state;
  }
};